import React, { createContext, useEffect, useReducer } from 'react'
import axios from '../../../axios';
import MatxLoading from "../../components/MatxLoading";

const initialValue = {
    feedbacks: []
};
const reducer = (state, action) => {
    switch (action.type) {
        case 'LOAD_FEEDBACK_DATA': {
            return {
                ...state,
                feedback_list: action.payload,
            }
        }
        default: {
            return state
        }
    }
}

const FeedbackContext = createContext({
    feedback_list: initialValue,
    getFeedback: () => {}
})

export const FeedbackProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialValue)

    const getFeedback = async () => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/sales/get_feedbacks', options);

            dispatch({
                type: 'LOAD_FEEDBACK_DATA',
                payload: res.data,
            })
        } catch (e) {
            console.error(e)
        }
    }

    useEffect(() => {
        getFeedback();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if(state.feedback_list === undefined) {
        return <MatxLoading />
    }

    return (
        <FeedbackContext.Provider
            value={{
                feedback_list: state.feedback_list,
                getFeedback
            }}
        >
            {children}
        </FeedbackContext.Provider>
    )
}

export default FeedbackContext
